import instance from "@/utils/require.js"

// 分页查询
export function apiSmtOrderSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/smt_order/search",
		method: "post",
		data
	})
}

// 生产工序--标签类型下拉
export function apiLabelType(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/label_type",
		method: "post",
		data
	})
}
// 生产工序--局胜制下拉
export function apiBestOf(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/best_of",
		method: "post",
		data
	})
}
// SMT测试工单详情
export function apiSmtOrderDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/smt_order/detail",
		method: "post",
		data
	})
}
// 切换到D803
export function apiSwitchToD803(data = {}) {
	return instance({
		url: "/aim/api/v3/smt_order/switch_to",
		method: "post",
		data
	})
}
// SMT测试工单PCBA状态列表
export function apiSmtOrderPcbaStatusList(data = {}) {
	return instance({
		url: "/aim/api/v3/smt_order/status_list",
		method: "post",
		data
	})
}
// SMT测试工单PCBA状态列表
export function apiSmtOrderPcbaStatus(data = {}) {
	return instance({
		url: "/aim/api/v3/smt_order/pcba_status",
		method: "post",
		data
	})
}
export function apiSmtOrderSopSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/smt_order/sop/search",
		method: "post",
		data
	})
}

// 拖拽排序
export function apiProductSopDragSort(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/drag_sort",
		method: "post",
		data
	})
}

// 生产工序--删除sop
export function apiProductSopDelete(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/delete",
		method: "post",
		data
	})
}

// 生产工序--下移sop
export function apiProductSopMoveDown(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/move_down",
		method: "post",
		data
	})
}

// 生产工序--上移sop
export function apiProductSopMoveUp(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/move_up",
		method: "post",
		data
	})
}

export function apiSmtOrderSopList(data = {}) {
	return instance({
		url: "/aim/api/v3/smt_order/sop/list",
		method: "post",
		data
	})
}
export function apiPcbaLife(data = {}) {
	return instance({
		url: "/aim/api/v3/smt_order/pcba/life",
		method: "post",
		data
	})
}
// PCBA SN 生命周期
export function apiPcbaSnLife(data = {}) {
	return instance({
		url: "/aim/api/v3/pcba/life",
		method: "post",
		data
	})
}
// SMT测试工单PCBA列表
export function apiSmtOrderPcbas(data = {}) {
	return instance({
		url: "/aim/api/v3/smt_order/pcbas",
		method: "post",
		data
	})
}
// 同步SMT测试工单
export function apiSmtOrderSync(data = {}) {
	return instance({
		url: "/aim/api/v3/smt_order/sync",
		method: "post",
		data
	})
}
export function apiSmtOrderAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/smt_order/add",
		method: "post",
		data
	})
}

// 工单详情--修改产品和固件版本
export function apiupdateSmtOrder(data = {}) {
    return instance({
        url: "/aim/api/v3/smt_order/update_smt_order",
        method: "post",
        data
    })
}

// 生产工序--新增sop
export function apiSmtSopAdd(data = {}) {
    return instance({
        url: "/aim/api/v3/smt_order/sop/add",
        method: "post",
        data
    })
}

// 生产工序--修改sop
export function apiSmtSopUpdate(data = {}) {
    return instance({
        url: "/aim/api/v3/smt_order/sop/update",
        method: "post",
        data
    })
}

export function apiSmtSopCopy(data={}) {
    return instance({
        url: "/aim/api/v3/smt_order/sop/copy_sop",
        method: "post",
        data
    })
}

// SMT工单--锁定
export function apiSmtOrderLockPcba(data = {}) {
    return instance({
        url: "/aim/api/v3/factory/lock_pcba",
        method: "post",
        data
    })
}

// SMT工单--借出
export function apiSmtOrderLendOutPcba(data = {}) {
    return instance({
        url: "/aim/api/v3/factory/lend_out",
        method: "post",
        data
    })
}

// SMT工单--解锁
export function apiSmtOrderUnlockPcba(data = {}) {
    return instance({
        url: "/aim/api/v3/factory/unlock_pcba",
        method: "post",
        data
    })
}

// SMT工单--回退工序
export function apiSmtOrderSopRollback(data = {}) {
    return instance({
        url: "/aim/api/v3/smt_order/sop/rollback",
        method: "post",
        data
    })
}
